export const GET_APP_TYPE_USER = "CACHE_GET_APP_TYPE_USER";

export interface GetAppTypeAction {
  type: typeof GET_APP_TYPE_USER;
  payload: {
    isAdmin: boolean;
  };
}
